import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { APIConstant } from '../constant/APIConstant'
import { environment } from '../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AIAdminConstant } from '../constant/AIAdminConstatnt';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private readonly apiService: ApiService, private readonly http: HttpClient) { }

  apiURL = environment.serviceUrl

  /*--- login Page ---*/
  checkURL = this.apiURL + APIConstant.login.checkLogin
  checkLogin = (body: any): Observable<any> => {
    return this.apiService.post(this.checkURL, body);
  };


  //getProjectMenu

  getProjectMenuURL = this.apiURL + APIConstant.header.getProjectMenu
  getProjectMenu = (body: any): Observable<any> => {
    return this.apiService.get(this.getProjectMenuURL + body)
  }

  /* -- Settings Page  --*/

  getChangePasswordURL = this.apiURL + APIConstant.settings.getChangePasswordConstant
  getChangePassword(data: any): Observable<any> {
    return this.apiService.post(this.getChangePasswordURL, data);
  }

  /*--- Try Now Screen ---*/

  getTryNowListURL = this.apiURL + APIConstant.tryNow.getTryNowConstant
  getTryNowList() {
    return this.apiService.get(this.getTryNowListURL);
  }

  getUpdateTryNowURL = this.apiURL + APIConstant.tryNow.getUpdateTryNowConstant
  getUpdateTrynow(data: any) {
    return this.apiService.post(this.getUpdateTryNowURL, data);
  }

  getSaveTryNowURL = this.apiURL + APIConstant.tryNow.getSaveTryNowFile
  getSaveTrynow(data: any) {
    return this.http.post(this.getSaveTryNowURL, data);
  }

  //getFetchTryNowURL = this.apiURL + APIConstant.tryNow.getFetchTryNowConstant
  getFetchTryNowURL = this.apiURL + APIConstant.tryNow.getFetchTryNowFile
  getFetchTrynow(data: any) {
    return this.http.post(this.getFetchTryNowURL, data, { responseType: 'text' });
  }

  getTryNowMail = this.apiURL + APIConstant.tryNow.getTryNowMail
  sendTrynowMail(data: any) {
    return this.http.post(this.getTryNowMail, data);
  }


  getOTPsendURL = this.apiURL + APIConstant.resetPassword.getOTP
  OtpSend(data: any): Observable<any> {
    return this.http.post(this.getOTPsendURL + data.mail + "&userName=" + data.userName, data);
  }

  getOTPcheckURL = this.apiURL + APIConstant.resetPassword.otpCheck
  otpCheck(data: any): Observable<any> {
    return this.http.post(this.getOTPcheckURL + data.mail + "&otp=" + data.otp, data);
  }

  getResetPasswordURL = this.apiURL + APIConstant.resetPassword.getresetPassword
  resetPassword(data: any): Observable<any> {
    return this.http.post(this.getResetPasswordURL, data);
  }

  getUserAccessByUserURL = this.apiURL + APIConstant.header.getAdmin
  getUserAccessByUser(getData: any): Observable<any> {
    return this.apiService.get(this.getUserAccessByUserURL + getData);
  }

  /*--- AI Admin ---*/

  myAIURL = environment.myAiURL

  // Method to generate common headers
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': ``,
    });
  }

  processDocument(data: FormData) {
    return this.http.post(this.myAIURL + 'process-document/', data, { headers: this.getHeaders() })
  }

  processDocumentWithKeyArea(id: any, data: FormData) {
    return this.http.post(this.myAIURL + AIAdminConstant.keyAreas.processDocument + id, data, { headers: this.getHeaders() })
  }

  getKeyAreas() {
    return this.http.get(this.myAIURL + AIAdminConstant.keyAreas.get, { headers: this.getHeaders() })
  }

  createKeyArea(data: any) {
    return this.http.post(this.myAIURL + AIAdminConstant.keyAreas.create, data, { headers: this.getHeaders() })
  }

  deleteKeyArea(id: any) {
    return this.http.delete(this.myAIURL + AIAdminConstant.keyAreas.delete + id + '/', { headers: this.getHeaders() })
  }

  updateKeyArea(id: any, data: any) {
    return this.http.put(this.myAIURL + AIAdminConstant.keyAreas.update + id + '/', data, { headers: this.getHeaders() })
  }

  getTemplateByID(id: any) {
    return this.http.get(this.myAIURL + AIAdminConstant.keyAreas.get_template + id + '/', { headers: this.getHeaders() })
  }

  updateTemplateByID(id: any, data: any) {
    return this.http.put(this.myAIURL + AIAdminConstant.keyAreas.update_template + id + '/', data, { headers: this.getHeaders() })
  }

  createMigScenario(data: any) {
    return this.http.post(this.myAIURL + 'migscenorios/create_mig_scenorio/', data, { headers: this.getHeaders() })
  }

  getMigScenario(id: any) {
    return this.http.get(this.myAIURL + 'migscenorios/get_mig_scenorio/' + id + '/', { headers: this.getHeaders() })
  }

  getScenarioList() {
    return this.http.get(this.myAIURL + 'migscenorios/get_mig_scenorio/', { headers: this.getHeaders() })
  }

  updateScenario(id: any, data: any) {
    return this.http.put(this.myAIURL + AIAdminConstant.scenario.update + id + '/', data, { headers: this.getHeaders() })
  }

  deleteScenario(id: any) {
    return this.http.delete(this.myAIURL + AIAdminConstant.scenario.delete + id + '/', { headers: this.getHeaders() })
  }

  getMigMapping(id: any) {
    return this.http.get(this.myAIURL + AIAdminConstant.scenario.getMigMapping + id, { headers: this.getHeaders() })
  }

  updateMigScenario(data: any) {
    return this.http.post(this.myAIURL + 'migscenorios/update_keyarea_mapping/', data, { headers: this.getHeaders() })
  }

  /*--- AI Admin Migration page ---*/

  processTemplate(data: any) {
    return this.http.post(this.myAIURL + `v2/admin/process-template/`, data, { headers: this.getHeaders() })
  }

  getMigScenarios() {
    return this.http.get(this.myAIURL + 'v2/admin/get-mig-scenarios/', { headers: this.getHeaders() })
  }

  updateScenarios(id: any, data: any) {
    return this.http.put(this.myAIURL + 'v2/admin/update-mig-scenorio/' + id + '/', data, { headers: this.getHeaders() })
  }

  deleteScenarios(id: any) {
    return this.http.delete(this.myAIURL + 'v2/admin/delete-mig-scenorio/' + id + '/', { headers: this.getHeaders() })
  }

  getKeyAreasByID(id: any) {
    return this.http.get(this.myAIURL + 'v2/admin/get-key-areas-by-migration/' + id + '/', { headers: this.getHeaders() })
  }

  updateTemplate(data: any) {
    return this.http.put(this.myAIURL + 'v2/admin/update_template/', data, { headers: this.getHeaders() })
  }

  updateKeyAreaDesc(data: any) {
    return this.http.put(this.myAIURL + 'v2/admin/update-key-areas-desc-migration/', data, { headers: this.getHeaders() })
  }

  deleteKeyAreaDesc(data: any) {
    return this.http.delete(this.myAIURL + 'v2/admin/delete-key-area/', { headers: this.getHeaders(), body: data })
  }

  create_context(data: any) {
    return this.http.post(this.myAIURL + AIAdminConstant.keyAreas.create_context, data, { headers: this.getHeaders() })
  }

  get_context(id: any) {
    return this.http.get(this.myAIURL + AIAdminConstant.keyAreas.get_context + id, { headers: this.getHeaders() })
  }

  delete_context(id: any) {
    return this.http.delete(this.myAIURL + AIAdminConstant.keyAreas.delete_context + id + '/', { headers: this.getHeaders() })
  }

  update_context(data: any) {
    return this.http.put(this.myAIURL + AIAdminConstant.keyAreas.update_context, data, { headers: this.getHeaders() })
  }

  downloadBlob(blob: string) {
    return this.http.get(this.myAIURL + AIAdminConstant.keyAreas.download_blob + blob, { headers: this.getHeaders(), responseType: 'blob' as 'json' })
  }

  getContext(id: string) {
    return this.http.get(this.myAIURL + AIAdminConstant.keyAreas.getContextID + id + "/", { headers: this.getHeaders() })
  }

  deleteFileChunks(body: any) {
    return this.http.delete(this.myAIURL + AIAdminConstant.keyAreas.deleteFileChunks, { headers: this.getHeaders(), body: body })
  }
  // deleteFileChunks(body: any){
  //   return this.http.delete(this.myAIURL + AIAdminConstant.keyAreas.deleteFileChunks + id + '/', { headers: this.getHeaders() })
  // }

  updatequestionariesstatus(data: any) {
    return this.http.put(this.myAIURL + AIAdminConstant.keyAreas.updtaequestionariesstatus, data, { headers: this.getHeaders() })
  }
  generate_questionnaire(data: any) {
    return this.http.post(this.myAIURL + AIAdminConstant.keyAreas.generate_questionnaire, data, { headers: this.getHeaders() })
  }
  //Listofquuestionaries
  Listofquuestionaries(id: string) {
    return this.http.get(this.myAIURL + AIAdminConstant.keyAreas.Listofquuestionaries + id + "/", { headers: this.getHeaders() })
  }
  downloadquestionnaries(id: string) {
    return this.http.get(this.myAIURL + AIAdminConstant.keyAreas.downloadquestionnaries + id + "/", { headers: this.getHeaders(), responseType: 'blob' as 'json' })
  }
  deletequestionary(id: any) {
    return this.http.delete(this.myAIURL + AIAdminConstant.keyAreas.deletequestionary + id + "/", { headers: this.getHeaders() })
  }

  // downloadAdminTemplate
  downloadAdminTemplate(id: string) {
    return this.http.get(this.myAIURL + AIAdminConstant.keyAreas.downloadAdminTemplate + id, { headers: this.getHeaders(), responseType: 'blob' as 'json' })
  }
  uploadQuestionary(data: any) {
    return this.http.post(this.myAIURL + AIAdminConstant.keyAreas.uploadQuestionary, data, { headers: this.getHeaders() })
  }
  create_group_chat(data: any) {
    return this.apiService.post(environment.qcamAiURL + AIAdminConstant.teams.create_group_chat, data)
  }
  add_members(data: any) {
    return this.apiService.post(environment.qcamAiURL + AIAdminConstant.teams.add_members, data)
  }
  delete_group_chat(groupname: any) {
    return this.apiService.delete(environment.qcamAiURL + AIAdminConstant.teams.delete_group_chat + '?group_name=' + groupname)
  }

  /*--- Send Simple Mail ---*/

  getSendSimpleMailURL = this.apiURL + APIConstant.tryNow.getSendSimpleMailConstant
  sendSimpleMail(data: any): Observable<any> {
    return this.apiService.post(this.getSendSimpleMailURL, data);
  }
}
